import { ThenaIcon } from "icons";

import { IIndexable } from "@customtypes/common";

import busd from "assets/images/defi/busd.png";

import bnbxIcon from "assets/images/defi/bnbx_light.png";
import bnbxDarkIcon from "assets/images/defi/bnbx_dark.png";
import bnbIcon from "assets/images/defi/bnb_light.png";
import etherLightIcon from "assets/images/defi/tether_light.png";
import fraxIcon from "assets/images/defi/frax.png";

import maticLight from "assets/images/defi/matic_circular.svg";
import maticDark from "assets/images/defi/matic_dark.svg";
import maticx from "assets/images/defi/maticx.svg";
import maticXDark from "assets/images/defi/maticx_dark.svg";
import usdc from "assets/images/defi/usdc.png";
import usdcDark from "assets/images/defi/usdc_dark.png";
import daiDark from "assets/images/defi/dai_dark.png";
import dai from "assets/images/defi/dai.png";

import btcIcon from "assets/images/defi/btc.png";
import ethIcon from "assets/images/defi/eth.png";

export const dappWalletMappings: IIndexable = {
  SD: [
    "metamask",
    "coinbasewallet",
    "walletconnect",
    "okx",
    "mathwallet",
    "safepal",
    "trustwallet",
    "coin98",
    "bitkeep",
    "coinhub",
    "nabox",
    "binance",
  ],
  ETH: [
    "metamask",
    "coinbasewallet",
    "walletconnect",
    "okx",
    "mathwallet",
    "safepal",
    "trustwallet",
    "coin98",
    "bitkeep",
    "coinhub",
    "nabox",
  ],
  BNB: [
    "metamask",
    "coinbasewallet",
    "walletconnect",
    "ledger",
    "okx",
    "mathwallet",
    "safepal",
    "trustwallet",
    "coin98",
    "bitkeep",
    "nabox",
    "binance",
    "ledgerLive",
  ],
  POLYGON: [
    "metamask",
    "coinbasewallet",
    "walletconnect",
    "okx",
    "mathwallet",
    "safepal",
    "trustwallet",
    "coin98",
    "bitkeep",
    "coinhub",
    "nabox",
  ],
};

export const defiCurrencyIconMapping: IIndexable = {
  bnbx: {
    light: bnbxIcon,
    dark: bnbxDarkIcon,
  },
  bnb: {
    light: bnbIcon,
    dark: bnbIcon,
  },
  busd: {
    light: busd,
    dark: busd,
  },
  ether: {
    light: etherLightIcon,
    dark: etherLightIcon,
  },
  matic: {
    light: maticLight,
    dark: maticDark,
  },
  maticx: {
    light: maticx,
    dark: maticXDark,
  },
  usdc: {
    light: usdc,
    dark: usdcDark,
  },
  dai: {
    light: dai,
    dark: daiDark,
  },
  frax: {
    light: fraxIcon,
    dark: fraxIcon,
  },
  thena: {
    light: ThenaIcon,
    dark: ThenaIcon,
  },
  btc: {
    light: btcIcon,
    dark: btcIcon,
  },
  eth: {
    light: ethIcon,
    dark: ethIcon,
  },
};
